module.exports = __webpack_public_path__ + "media/jingle_muteki.0dde0428.mp3";